import React, {useState, useEffect} from "react";
import {motion} from "framer-motion";
import tw from "twin.macro";
import styled from "styled-components";
import {css} from "styled-components/macro"; //eslint-disable-line
import {Link} from "react-router-dom";

import {Container} from "components/misc/Layouts.js";

const TabContent = tw(
  motion.div
)` mt-5 grid grid-cols-2 gap-4 md:grid-cols-4 md:gap-4 lg:grid-cols-5 lg:gap-6`;

const CardImageContainer = styled.div`
  ${(props) =>
    css`
      background-image: url("${props.imageSrc}");
    `}
  ${tw`h-56 md:h-56 lg:h-80 bg-center bg-cover relative rounded-t`}
`;

const ContentWithPaddingXl = tw.div`max-w-screen-xl mx-auto p-5 py-5 lg:py-10`;
const Header = tw.div`text-xl font-bold text-gray-900`;

function Gallery({gallery}) {

  return (
    <Container>
    <ContentWithPaddingXl>
        {gallery && gallery.length >0 && <Header>Gallery</Header>} 
      {/* <AdComponent/>  */}
      <TabContent>
          {gallery && gallery.map((items) => (
                <CardImageContainer imageSrc={items.cover_url} />

        ))}
      </TabContent>
      </ContentWithPaddingXl>
    </Container>
  )
}

export default Gallery